import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import authReducer from './slices/authSlice';
import apiKeyReducer from './slices/apiKeySlice';
import usageReducer from './slices/usageSlice';
import chatReducer from './slices/chatSlice';
import { setupAxiosInterceptors } from './axios';

const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['accessToken', 'refreshToken', 'user', 'onboardingComplete', 'userType'],
};

const chatPersistConfig = {
  key: 'chat',
  storage,
  whitelist: ['conversations', 'messages'],
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  apiKeys: apiKeyReducer,
  usage: usageReducer,
  chat: persistReducer(chatPersistConfig, chatReducer),
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

setupAxiosInterceptors(store);
